<template>
  <h3 class="text-2xl font-semibold leading-6 text-gray-900">
    Recent App Updates
  </h3>

  <div class="bg-white mt-5 px-4 shadow rounded-lg">
    <ul role="list" class="divide-y divide-gray-100">
      <li v-for="update in recentUpdates" :key="update.date" class="flex gap-x-4 py-5">
        <div class="flex-auto">
          <div class="flex items-baseline justify-between gap-x-4">
            <p class="font-semibold leading-6 text-gray-900">
              {{ update.title }}
            </p>
            <p class="flex-none text-sm text-gray-600">
              <time :datetime="update.date">{{ update.date }}</time>
            </p>
          </div>
          <p class="mt-1 text-sm leading-6 text-gray-600">{{ update.details }}</p>
        </div>
      </li>
    </ul>
  </div>

</template>

<script lang="ts" setup>
import appUpdates from '@/data/app-updates.json';

const recentUpdates = appUpdates.sort(function (a, b) {
  // @ts-ignore
  return new Date(b.date) - new Date(a.date);
}).slice(0, 5);

</script>
